import * as React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import ConfirmPopup from './ConfirmPopup';
import { CustomerDetails } from './models/CustomerInterfaces';
import { GenericList } from './models/JobSharedInterfaces';

interface CustomerProps {
    id: number;
    systemCompanyId: number;
    reckonSwitchedon: boolean;
    readOnly: boolean;
    customerDetails: CustomerDetails;
    errors: { [key: string]: string };
    updateAccountType(newAcctTypeId: number): void;
    updateDetailsString(fieldName: string, fieldValue: string): void;
    updateDetailsNumber(fieldName: string, fieldValue: number): void;
    updateDetailsChecked(fieldName: string, fieldValue: boolean, unsetFieldName: string): void;
    updateCustomer(customer: CustomerDetails): void;
    updateErrors(errors: { [key: string]: string }): void;
}


interface ReckonCustomer {
    listId: string;
    customerName: string;
    abn: string;
    reckonStreetName: string;
    reckonSuburb: string;
    reckonState: string;
    reckonPostCode: string;
    accountTypeId: number;
    terms: number;
    accountContact: string;
    phone: string;
    invoiceEmail: string;
    creditLimit: number;
    selected: boolean;
}

const win: any = window;
const Stimulsoft = win.Stimulsoft;
let timeout;

const CustomerDetail = (props: CustomerProps) => {
    const [reckonScaffoldCustomerName, setReckonScaffoldCustomerName] = React.useState("");
    const [reckonDunnyCustomerName, setReckonDunnyCustomerName] = React.useState("");
    const [canCreateAccountCustomers, setCanCreateAccountCustomers] = React.useState(false);
    const [canRunActiveJobsReport, setCanRunActiveJobsReport] = React.useState(false);
    const [accountTypes, setAccountTypes] = React.useState <GenericList[]>([]);
    const [statusOptions, setStatusOptions] = React.useState<GenericList[]>([]);
    const [statusTypeOptions, setStatusTypeOptions] = React.useState<GenericList[]>([]);
    const [termsOptions, setTermsOptions] = React.useState<GenericList[]>([]);
    const [reckonScaffoldCustomerResults, setReckonScaffoldCustomerResults] = React.useState<ReckonCustomer[]>([]);
    const [reckonDunnyCustomerResults, setReckonDunnyCustomerResults] = React.useState<ReckonCustomer[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [searchingDunny, setSearchingDunny] = React.useState(false);
    const [searchingScaffold, setSearchingScaffold] = React.useState(false);
    const [searchingReckon, setSearchingReckon] = React.useState(false);
    const [showConfirmClearReckon, setShowConfirmClearReckon] = React.useState(false);
    const [reckonTypeId, setReckonTypeId] = React.useState(0);
    const [balance, setBalance] = React.useState("");

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, [props.customerDetails.id]);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Customer/GetCustomerDetailsDropdowns?SubId=' + user.sub + '&CustomerId=' + props.customerDetails.id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setCanCreateAccountCustomers(res.data.canCreateAccountCustomers);
            setCanRunActiveJobsReport(res.data.canRunActiveJobsReport);
            setAccountTypes(res.data.accountTypes);
            setStatusOptions(res.data.statusOptions);
            setStatusTypeOptions(res.data.statusTypeOptions);
            setTermsOptions(res.data.termsOptions);
            setLoading(false);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const searchScaffoldReckon = () => {
        if (reckonScaffoldCustomerName === "") {
            var errorList = props.errors;
            toast.error("Enter a Scaffold Customer Name to search Reckon!");
            errorList["reckonScaffoldCustomerName"] = "Enter a Scaffold Customer Name to search Reckon!";
            props.updateErrors(errorList);
            return;
        }

        setSearchingScaffold(true);
        searchScaffReckon();
    }

    const searchScaffReckon = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var errorsList = props.errors;
        axios.get('api/Customer/ReckonScaffoldCustomerSearch?CustomerName=' + reckonScaffoldCustomerName + "&SubId=" + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                setSearchingScaffold(false);
                toast.error("Error when search Scaffold Reckon: " + res.data.errorMessage);
                errorsList["reckonScaffoldCustomerName"] = res.data.errorMessage;
                props.updateErrors(errorsList);
                
            } else {
                delete errorsList["reckonScaffoldCustomerName"];
                props.updateErrors(errorsList);
                setSearchingScaffold(false);
                setReckonScaffoldCustomerResults(res.data.customerResults)
            }
        })
        .catch(error => {
            setSearchingScaffold(false);
            toast.error(error.message);
        });
    }

    const searchDunnyReckon = () => {
        if (reckonDunnyCustomerName === "") {
            toast.error("Enter a Dunny Customer Name to search Reckon!");
            var errorList = props.errors;
            errorList["reckonDunnyCustomerName"] = "Enter a Dunny Customer Name to search Reckon!";
            props.updateErrors(errorList);
            return;
        }
        
        setSearchingDunny(true);
        searchDunnyCustReckon();
    }

    const searchDunnyCustReckon = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var errorsList = props.errors;

        axios.get('api/Customer/ReckonDunnyCustomerSearch?CustomerName=' + reckonDunnyCustomerName + "&SubId=" + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                setSearchingDunny(false);
 
                toast.error("Error when search Dunny Reckon: " + res.data.errorMessage);
                errorsList["reckonDunnyCustomerName"] = res.data.errorMessage;
                props.updateErrors(errorsList);
            } else {
                delete errorsList["reckonDunnyCustomerName"];
                props.updateErrors(errorsList);
                setSearchingDunny(false);
                setReckonDunnyCustomerResults(res.data.customerResults)
            }
        })
        .catch(error => {
            setSearchingDunny(false);
            toast.error(error.message);
        });
    }

    const handleReckonScaffoldCustomerCheckboxChange = (e: any, index: number) => {
        var custResults = [...reckonScaffoldCustomerResults];

        //uncheck all results first as can only select one
        for (var i = 0; i < custResults.length; i++) {
            var item = custResults[i];
            item.selected = false;
        }

        var custResult = custResults[index];
        custResult.selected = e.target.checked;
        setReckonScaffoldCustomerResults(custResults);
        updateError("reckonScaffoldCheck");

        let acctId = "";
        let compName = "";
        let acctLimit = 0;
        let abn = "";
        let streetName = "";
        let suburb = "";
        let state = "";
        let postCode = "";
        let accountTypeId = -1;
        let terms = -1;
        let accountContact = "";
        let phone = "";
        let invoiceEmail = "";
        if (e.target.checked) {
            acctId = custResult.listId;
            compName = custResult.customerName;
            acctLimit = custResult.creditLimit;
            abn = custResult.abn;
            streetName = custResult.reckonStreetName;
            suburb = custResult.reckonSuburb;
            state = custResult.reckonState;
            postCode = custResult.reckonPostCode;
            accountTypeId = custResult.accountTypeId;
            terms = custResult.terms;
            accountContact = custResult.accountContact;
            phone = custResult.phone;
            invoiceEmail = custResult.invoiceEmail;
        } else {
            acctId = "";
        }

        //update the account id on the customer
        props.updateDetailsString("accountId", acctId);
        if (compName != "") {
            if (props.customerDetails.id === 0) {
                //only want to update customer names for new customers
                props.updateDetailsString("name", compName);
                props.updateDetailsString("abn", abn);
                props.updateDetailsNumber("accountTypeId", accountTypeId);
                props.updateDetailsNumber("terms", terms);
                props.updateDetailsString("accountContact", accountContact);
                props.updateDetailsString("phone", phone);
                props.updateDetailsString("invoiceEmail", invoiceEmail);
            }
            props.updateDetailsString("streetName", streetName);
            props.updateDetailsString("suburb", suburb);
            props.updateDetailsString("state", state);
            props.updateDetailsString("postCode", postCode);
            props.updateDetailsString("internalName", compName);
            props.updateDetailsNumber("accountLimit", acctLimit);
        }
    }

    const handleReckonScaffoldCustomerCheckChange = (e: any, listId: string) => {
        var custResults = [...reckonScaffoldCustomerResults];
        var custResult = custResults.find(r => r.listId === listId);
        if (custResult) {
            custResult.selected = e.target.checked;
            setReckonScaffoldCustomerResults(custResults);
            updateError("reckonScaffoldCheck");

            let acctId = "";
            if (e.target.checked) {
                acctId = custResult.listId;
            } else {
                acctId = "";
            }

            props.updateDetailsString("accountId", acctId);
        }
    }

    const handleReckonDunnyCustomerCheckboxChange = (e: any, index: number) => {
        var custResults = [...reckonDunnyCustomerResults];

        //uncheck all results first as can only select one
        for (var i = 0; i < custResults.length; i++) {
            var item = custResults[i];
            item.selected = false;
        }

        var custResult = custResults[index];
        custResult.selected = e.target.checked;
        setReckonDunnyCustomerResults(custResults);
        updateError("reckonDunnyCheck");

        let acctId = "";
        let compName = "";
        let acctLimit = 0;
        let abn = "";
        let streetName = "";
        let suburb = "";
        let state = "";
        let postCode = "";
        let accountTypeId = -1;
        let terms = -1;
        let accountContact = "";
        let phone = "";
        let invoiceEmail = "";
        if (e.target.checked) {
            acctId = custResult.listId;
            compName = custResult.customerName;
            acctLimit = custResult.creditLimit;
            abn = custResult.abn;
            streetName = custResult.reckonStreetName;
            suburb = custResult.reckonSuburb;
            state = custResult.reckonState;
            postCode = custResult.reckonPostCode;
            accountTypeId = custResult.accountTypeId;
            terms = custResult.terms;
            accountContact = custResult.accountContact;
            phone = custResult.phone;
            invoiceEmail = custResult.invoiceEmail;
        } else {
            acctId = "";
        }

        //update the account id on the customer
        props.updateDetailsString("accountIdDunny", acctId);
        if (compName != "") {
            if (props.customerDetails.id === 0) {
                //only want to update customer names for new customers
                props.updateDetailsString("name", compName);
                props.updateDetailsString("internalName", compName);
                props.updateDetailsString("abn", abn);
                props.updateDetailsNumber("accountTypeId", accountTypeId);
                props.updateDetailsNumber("terms", terms);
                props.updateDetailsString("accountContact", accountContact);
                props.updateDetailsString("phone", phone);
                props.updateDetailsString("invoiceEmail", invoiceEmail);
            }
            props.updateDetailsString("streetName", streetName);
            props.updateDetailsString("suburb", suburb);
            props.updateDetailsString("state", state);
            props.updateDetailsString("postCode", postCode);
            props.updateDetailsNumber("accountLimitDunny", acctLimit);
        }
    }

    const handleReckonDunnyCustomerCheckChange = (e: any, listId: string) => {
        var custResults = [...reckonDunnyCustomerResults];
        var custResult = custResults.find(r => r.listId === listId);
        if (custResult) {
            custResult.selected = e.target.checked;
            setReckonDunnyCustomerResults(custResults);
            updateError("reckonDunnyCheck");

            let acctId = "";
            if (e.target.checked) {
                acctId = custResult.listId;
            } else {
                acctId = "";
            }

            props.updateDetailsString("accountIdDunny", acctId);
        }
    }

    const clearReckonId = (reckonAcctTypeId: number) => {
        //reckonTypeId => 1 = Scaffold, 2 = Dunny
        setShowConfirmClearReckon(true);
        setReckonTypeId(reckonAcctTypeId);
    }

    const hideConfirmModal = () => {
        setShowConfirmClearReckon(false);
        setReckonTypeId(0);
    }

    const saveConfirmModal = () => {
        //reckonTypeId => 1 = Scaffold, 2 = Dunny
        clearReckonAccountId(reckonTypeId);
    }

    const clearReckonAccountId = async (reckonTypeId: number) => {
        const token = await authService.getAccessToken();

        var clearReckonId = {
            customerId: props.customerDetails.id,
            reckonTypeId: reckonTypeId
        };

        axios.post('api/Customer/ClearReckonAccountId', clearReckonId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            //check if there was an error
            if (res.data.isError) {
                for (var i = 0; i < res.data.messages.length; i++) {
                    toast.error(res.data.messages[i].content);
                }
            } else {
                if (reckonTypeId === 1) {
                    props.updateDetailsString("accountId", "");
                    props.updateDetailsChecked("isLinkedToReckonScaffold", false, "");
                } else {
                    props.updateDetailsString("accountIdDunny", "");
                    props.updateDetailsChecked("isLinkedToReckonDunny", false, "");
                }
                setShowConfirmClearReckon(false);
                setReckonTypeId(0);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const getReckonData = (reckonAcctTypeId: number) => {
        setSearchingReckon(true);
        getDataFromReckon(reckonAcctTypeId);
    }

    const getDataFromReckon = async (reckonAcctTypeId: number) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var customer = props.customerDetails;
        var companyId = reckonAcctTypeId === 1 ? 2 : 3;
        var customerId = reckonAcctTypeId === 1 ? props.customerDetails.accountId : props.customerDetails.accountIdDunny;
        axios.get('api/Customer/GetReckonData?CustomerId=' + customerId + "&CompanyId=" + companyId + "&SubId=" + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                setSearchingReckon(false);
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                setSearchingReckon(false);
                setBalance(res.data.balanceFormatted);
                customer.streetName = res.data.streetName;
                customer.suburb = res.data.suburb;
                customer.postCode = res.data.postCode;
                customer.state = res.data.state;
                customer.country = res.data.country;
                customer.accountTypeId = res.data.accountTypeId;
                customer.accountContact = res.data.accountContact;
                customer.phone = res.data.phone;
                customer.invoiceEmail = res.data.invoiceEmail;
                customer.terms = res.data.terms;
                if (companyId === 2) {
                    customer.accountLimit = res.data.accountLimit;
                } else {
                    customer.accountLimitDunny = res.data.accountLimitDunny;
                }
                props.updateCustomer(customer);
            }
        })
        .catch(error => {
            setSearchingReckon(false);
            toast.error(error.message);
        });
    }


    const handleCheckboxChange = (e: any) => {
        //reset the other checkbox
        var unused = e.target.name === "createScaffoldAccount" ? "scaffoldNotUsed" : e.target.name === "scaffoldNotUsed" ? "createScaffoldAccount" : e.target.name === "createDunnyAccount" ? "dunnyNotUsed" : e.target.name === "dunnyNotUsed" ? "createDunnyAccount" : ""  ;

        props.updateDetailsChecked(e.target.name, e.target.checked, unused);
    }

    const updateError = (errorName: string) => {
        var error = props.errors;
        if (errorName) {
            delete error[errorName];
            if (errorName === "accountTypeId") {
                //clear account limit scaffold and dunny
                delete error["accountLimit"];
                delete error["accountLimitDunny"];
            }
            props.updateErrors(error);
        }
    }

    const handleAcctChange = (e: any) => {
        updateError(e.target.name);
        props.updateAccountType(e.target.value * 1);
    }

    const handleChangeString = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        updateError(e.target.name);
        props.updateDetailsString(e.target.name, e.target.value);
    }

    const handleChangeNumber = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        updateError(e.target.name);
        props.updateDetailsNumber(e.target.name, e.target.value * 1);
    }

    const handleNameChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        updateError(e.target.name);

        var value = e.target.value;
        var custName = value.replace(/[^0-9a-z.() /&'-]/gi, '');

        props.updateDetailsString(e.target.name, custName);
    }

    const handleGSTChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        updateError(e.target.name);

        if (e.target.name == "abn") {
            props.updateDetailsString("abn", e.target.value);
            props.updateDetailsString("acn", "");
        } else {
            props.updateDetailsString("abn", "");
            props.updateDetailsString("acn", e.target.value);
        }
    }

    //END Download Active Jobs Report
    const runActiveJobsReport = (e: any) => {
        e.preventDefault();

        downloadActiveJobs();
    }

    const downloadActiveJobs = async () => {
        const token = await authService.getAccessToken();

        axios.get('api/Report/GetCustomerActiveJobs?CustomerId=' + props.customerDetails.id + "&customerName=" + props.customerDetails.name, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var activeJobs = res.data.reportData;

            let report = new Stimulsoft.Report.StiReport();
            let reportFile = Stimulsoft.System.IO.File.getFile("reports/" + res.data.reportFileName);
            report.load(reportFile);

            report.dictionary.dataStore.clear();

            let reportData = JSON.stringify(activeJobs);
            //Dataset created
            let dataSet = new Stimulsoft.System.Data.DataSet("data");
            dataSet.readJson(reportData)
            report.regData(dataSet.dataSetName, "", dataSet);
            report.reportName = res.data.reportName;
            report.dictionary.connect(false);
            report.dictionary.synchronize();

            //add relationships between data
            for (var i = 0; i < res.data.reportRelationships.length; i++) {
                var dataRelation = new Stimulsoft.Report.Dictionary.StiDataRelation(res.data.reportRelationships[i].sourceName, res.data.reportRelationships[i].name, res.data.reportRelationships[i].alias, report.dictionary.dataSources.getByName(res.data.reportRelationships[i].parentTableName), report.dictionary.dataSources.getByName(res.data.reportRelationships[i].childTableName), [res.data.reportRelationships[i].parentFieldName], [res.data.reportRelationships[i].childFieldName]);
                report.dictionary.relations.add(dataRelation);
                report.dictionary.synchronize();
            }
            report.render();

            let fileName = res.data.reportName;

            timeout = setTimeout(downloadReportToPdf, 1000, report, fileName);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const downloadReportToPdf = (report: any, fileName: string) => {
        report.exportDocumentAsync(function (pdfData: any) {
            // Save data to file
            Stimulsoft.System.StiObject.saveAs(pdfData, fileName + ".pdf", "application/pdf");
        }, Stimulsoft.Report.StiExportFormat.Pdf);
    }
    //END Download Active Jobs Report

    let scaffoldCheck = props.customerDetails.accountId != "" || props.customerDetails.createScaffoldAccount || props.customerDetails.scaffoldNotUsed;
    let dunnyCheck = props.customerDetails.accountIdDunny != "" || props.customerDetails.createDunnyAccount || props.customerDetails.dunnyNotUsed;
    let canUpdate = !props.reckonSwitchedon || props.customerDetails.id > 0 || (scaffoldCheck && dunnyCheck);
    let reckonScaffItem = reckonScaffoldCustomerResults.find(r => r.selected || r.listId === props.customerDetails.accountId);
    let reckonDunnyItem = reckonDunnyCustomerResults.find(r => r.selected || r.listId === props.customerDetails.accountIdDunny);
    let confirmPopup = <ConfirmPopup heading="Unlink Reckon Id?" text="Are you sure you want to unlink this customer from Reckon?" hideConfirmModal={hideConfirmModal} showConfirmModal={showConfirmClearReckon} saveConfirmModal={saveConfirmModal} />

    const renderDetails = (
        <div>
            <div className="static-modal">
                {confirmPopup}
            </div>
            <div>
                <label className="input-group" htmlFor="statusTypeId">
                    <span className="label label-large">Status Type</span>
                    <select className={props.readOnly ? "hidden" : props.customerDetails.id === 0 ? "select" : "marginRight10"} id="statusTypeId" name="statusTypeId" value={props.customerDetails.statusTypeId} onChange={(e) => handleChangeNumber(e)} disabled={props.customerDetails.existingStatusTypeId == 3}>
                        <option hidden defaultValue="-1"></option>
                        {statusTypeOptions.map(statusType =>
                            <option key={statusType.id} value={statusType.id}>{statusType.name}</option>
                        )};
                    </select>
                    <span className={props.readOnly ? "marginRight10" : "hidden"}>{props.customerDetails.statusType}</span>
                    <button type="button" className={props.customerDetails.id === 0 || !canRunActiveJobsReport ? "hidden" : "defaultbutton defaultbutton__small"} onClick={(e) => runActiveJobsReport(e)}>Active Jobs</button>
                </label>
                <span className={props.errors["statusTypeId"] ? "label errors marginLeftLabelLarge" : "hidden"}>{props.errors["statusTypeId"]}</span>
            </div>

            <hr></hr>
            <label className={props.customerDetails.id === 0 ? "hidden" : "input-group"} htmlFor="scaffoldReckonLinked">
                <span className="label label-large">Scaffold Reckon Linked</span>
                <input className="checkbox marginRight50" type="checkbox" checked={props.customerDetails.isLinkedToReckonScaffold} readOnly disabled></input>
                <button type="button" className={props.customerDetails.isLinkedToReckonScaffold && props.customerDetails.id > 0 ? "customer__unlinkbtn--size marginRight10" : "hidden"} onClick={(e) => clearReckonId(1)} disabled={props.readOnly}>Unlink Reckon</button>
                <button type="button" className={props.customerDetails.isLinkedToReckonScaffold && props.customerDetails.id > 0 && props.systemCompanyId === 2 ? "customer__unlinkbtn--size  marginRight10" : "hidden"} onClick={(e) => getReckonData(1)} disabled={props.readOnly || searchingReckon}>Get Reckon Data</button><span className={searchingReckon && props.systemCompanyId === 2 ? "" : "hidden"}>Searching Reckon...</span><span className={!searchingReckon && props.systemCompanyId === 2 && balance != "" ? "" : "hidden"}>Balance: {balance}</span>
            </label>
            <div className={props.reckonSwitchedon && !props.readOnly && !props.customerDetails.isLinkedToReckonScaffold && props.customerDetails.statusTypeId === 3 ? "" : "hidden"}>
                <div>Search and Select a customer from Reckon Scaffold to link this customer to an existing Scaffold Reckon customer <b>OR</b></div>
                <div className="marginBottom10">Tick "Create Scaff Reckon Cust" which will use the customer details entered to create a customer on Scaffold Reckon <b>OR</b></div>
                <div className="marginBottom10">Select "Scaffold Reckon Not Used" if this customer WILL NOT be used for Scaffold jobs. NOTE: You need to link to Dunny Reckon to use this.</div>
                <label className="input-group" htmlFor="reckonScaffoldCustomerName">
                    <span className="label label-large">Scaff Reckon Cust Name</span>
                    <input className="input marginRight10" type="text" id="reckonScaffoldCustomerName" name="reckonScaffoldCustomerName" value={reckonScaffoldCustomerName} onChange={(e) => setReckonScaffoldCustomerName(e.target.value)}></input>
                    <button type="button" className="defaultbutton marginRight10" title="Search Scaffold Reckon for a customer that matches the entered customer name." onClick={searchScaffoldReckon} disabled={reckonScaffoldCustomerName === "" || searchingScaffold}>Search Scaffold Reckon</button>
                    <span>{searchingScaffold ? "Searching..." : ""}</span>
                </label>
                <span className="label errors marginLeftLabel">{props.errors["reckonScaffoldCustomerName"]}</span>

                <div className={reckonScaffoldCustomerResults.length > 0 && props.customerDetails.accountId === "" ? "marginLeftLabel" : "hidden"}>
                    {reckonScaffoldCustomerResults.map((customer, index) => 
                        <div>
                            <input className="checkbox marginRight10" type="checkbox" checked={customer.selected} onClick={(e) => handleReckonScaffoldCustomerCheckboxChange(e, index)}></input>
                            {customer.customerName}
                        </div>
                    )}
                </div>
                <div className={reckonScaffItem ? "marginLeftLabel" : "hidden"}>
                    <div>
                        <input className="checkbox marginRight10" type="checkbox" checked={reckonScaffItem?.selected} onClick={(e) => handleReckonScaffoldCustomerCheckChange(e, reckonScaffItem?.listId ?? "")}></input>
                        {reckonScaffItem?.customerName}
                    </div>
                </div>

                <label className="input-group" htmlFor="createScaffoldAccount">
                    <span className="label label-large">Create Scaff Reckon Cust</span>
                    <input className="checkbox" type="checkbox" id="createScaffoldAccount" name="createScaffoldAccount" checked={props.customerDetails.createScaffoldAccount} onClick={(e) => handleCheckboxChange(e)} disabled={props.customerDetails.accountId != ""}></input>
                </label>

                <label className="input-group" htmlFor="scaffoldNotUsed">
                    <span className="label label-large">Scaffold Reckon Not Used</span>
                    <input className="checkbox" type="checkbox" id="scaffoldNotUsed" name="scaffoldNotUsed" checked={props.customerDetails.scaffoldNotUsed} onClick={(e) => handleCheckboxChange(e)} disabled={props.customerDetails.accountId != ""}></input>
                </label>
                <span className="label errors">{props.errors["reckonScaffoldCheck"]}</span>
                <hr></hr>
            </div>

            <label className={props.customerDetails.id === 0 ? "hidden" : "input-group"} htmlFor="dunnyReckonLinked">
                <span className="label label-large">Dunny Reckon Linked</span>
                <input className="checkbox marginRight50" type="checkbox" checked={props.customerDetails.isLinkedToReckonDunny} readOnly disabled></input>
                <button type="button" className={props.customerDetails.isLinkedToReckonDunny && props.customerDetails.id > 0 ? "customer__unlinkbtn--size marginRight10" : "hidden"} onClick={(e) => clearReckonAccountId(2)} disabled={props.readOnly}>Unlink Reckon</button>
                <button type="button" className={props.customerDetails.isLinkedToReckonDunny && props.customerDetails.id > 0 && props.systemCompanyId === 3 ? "customer__unlinkbtn--size marginRight10" : "hidden"} onClick={(e) => getReckonData(2)} disabled={props.readOnly || searchingReckon}>Get Reckon Data</button><span className={searchingReckon && props.systemCompanyId === 3 ? "" : "hidden"}>Searching Reckon...</span><span className={!searchingReckon && props.systemCompanyId === 3 && balance != "" ? "" : "hidden"}>Balance: {balance}</span>
            </label>
            <div className={props.reckonSwitchedon && !props.readOnly && !props.customerDetails.isLinkedToReckonDunny && props.customerDetails.statusTypeId === 3 ? "" : "hidden"}>
                <div>Search and Select a customer from Reckon Dunny to link this customer to an existing Dunny Reckon customer <b>OR</b></div>
                <div className="marginBottom10">Tick "Create Dunny Reckon Cust" which will use the customer details entered to create a customer on Dunny Reckon <b>OR</b></div>
                <div className="marginBottom10">Select "Dunny Reckon Not Used" if this customer WILL NOT be used for Dunny jobs. NOTE: You need to link to Scaffold Reckon to use this.</div>
                <label className="input-group" htmlFor="reckonDunnyCustomerName">
                    <span className="label label-large">Dunny Reckon Cust Name</span>
                    <input className="input marginRight10" type="text" id="reckonDunnyCustomerName" name="reckonDunnyCustomerName" value={reckonDunnyCustomerName} onChange={(e) => setReckonDunnyCustomerName(e.target.value)}></input>
                    <button type="button" className="defaultbutton marginRight10" title="Search Dunny Reckon for a customer that matches the entered customer name." onClick={searchDunnyReckon} disabled={reckonDunnyCustomerName === "" || searchingDunny} >Search Dunny Reckon</button>
                    <span>{searchingDunny ? "Searching..." : ""}</span>
                </label>
                <span className="label errors marginLeftLabel">{props.errors["reckonDunnyCustomerName"]}</span>

                <div className={reckonDunnyCustomerResults.length > 0 && props.customerDetails.accountIdDunny === "" ? "marginLeftLabel" : "hidden"}>
                    {reckonDunnyCustomerResults.map((customer, index) =>
                        <div>
                            <input className="checkbox marginRight10" type="checkbox" checked={customer.selected} onClick={(e) => handleReckonDunnyCustomerCheckboxChange(e, index)}></input>
                            {customer.customerName}
                        </div>
                    )}
                </div>
                <div className={reckonDunnyItem ? "marginLeftLabel" : "hidden"}>
                    <div>
                        <input className="checkbox marginRight10" type="checkbox" checked={reckonDunnyItem?.selected} onClick={(e) => handleReckonDunnyCustomerCheckChange(e, reckonDunnyItem?.listId ?? "")}></input>
                        {reckonDunnyItem?.customerName}
                    </div>
                </div>

                <label className="input-group" htmlFor="createDunnyAccount">
                    <span className="label label-large">Create Dunny Reckon Cust</span>
                    <input className="checkbox" type="checkbox" id="createDunnyAccount" name="createDunnyAccount" checked={props.customerDetails.createDunnyAccount} onClick={(e) => handleCheckboxChange(e)} disabled={props.customerDetails.accountIdDunny != ""}></input>
                </label>

                <label className="input-group" htmlFor="dunnyNotUsed">
                    <span className="label label-large">Dunny Reckon Not Used</span>
                    <input className="checkbox" type="checkbox" id="dunnyNotUsed" name="dunnyNotUsed" checked={props.customerDetails.dunnyNotUsed} onClick={(e) => handleCheckboxChange(e)} disabled={props.customerDetails.accountIdDunny != ""}></input>
                </label>
                <span className="label errors">{props.errors["reckonDunnyCheck"]}</span>
            </div>
            <hr></hr>

            <label className="input-group" htmlFor="name">
                <span className="label label-large">Company Name</span>
                <input className="input" type="text" id="name" name="name" value={props.customerDetails.name} onChange={(e) => handleNameChange(e)} disabled={props.readOnly}></input>
            </label>
            <span className="label errors marginLeftLabelLarge">{props.errors["name"]}</span>
            
            <label className="input-group" htmlFor="internalName">
                <span className="label label-large">Reckon Name</span>
                <input className="input" type="text" id="internalName" name="internalName" value={props.customerDetails.internalName} onChange={(e) => handleChangeString(e)} disabled={props.readOnly}></input>
            </label>
            <span className="label errors marginLeftLabelLarge">{props.errors["internalName"]}</span>

            <div className={canUpdate || props.customerDetails.statusTypeId < 3 ? "" : "hidden"}>
                <label className="input-group" htmlFor="streetName">
                    <span className="label label-large">Address 1</span>
                    <input className="input" maxLength={41} type="text" id="streetName" name="streetName" value={props.customerDetails.streetName} onChange={(e) => handleChangeString(e)} disabled={props.readOnly}></input>
                </label>
                <span className="label errors marginLeftLabelLarge">{props.errors["streetName"]}</span>

                <label className="input-group" htmlFor="streetNameTwo">
                    <span className="label label-large">Address 2</span>
                    <input className="input" maxLength={41} type="text" id="streetNameTwo" name="streetNameTwo" value={props.customerDetails.streetNameTwo} onChange={(e) => handleChangeString(e)} disabled={props.readOnly}></input>
                </label>

                <label className="input-group" htmlFor="suburb">
                    <span className="label label-large">Suburb</span>
                    <input className="input" maxLength={25} type="text" id="suburb" name="suburb" value={props.customerDetails.suburb} onChange={(e) => handleChangeString(e)} disabled={props.readOnly}></input>
                </label>
                <span className="label errors marginLeftLabelLarge">{props.errors["suburb"]}</span>

                <label className="input-group" htmlFor="state">
                    <span className="label label-large">State</span>
                    <input className="input" maxLength={25} type="text" id="state" name="state" value={props.customerDetails.state} onChange={(e) => handleChangeString(e)} disabled={props.readOnly}></input>
                </label>
                <span className="label errors marginLeftLabelLarge">{props.errors["state"]}</span>

                <label className="input-group" htmlFor="postCode">
                    <span className="label label-large">Post Code</span>
                    <input className="input" maxLength={10} type="text" id="postCode" name="postCode" value={props.customerDetails.postCode} onChange={(e) => handleChangeString(e)} disabled={props.readOnly}></input>
                </label>
                <span className="label errors marginLeftLabelLarge">{props.errors["postCode"]}</span>

                <label className="input-group" htmlFor="gstRegistered">
                    <span className="label label-large">Does Customer have an ABN?</span>
                    <select className="select" id="gstRegistered" name="gstRegistered" value={props.customerDetails.gstRegistered} onChange={(e) => handleChangeNumber(e)} disabled={props.readOnly}>
                        <option hidden defaultValue="-1"></option>
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                    </select>
                </label>
                <span className="label errors marginLeftLabelLarge">{props.errors["gstRegistered"]}</span>
            
                <div className={props.customerDetails.gstRegistered == 0 ? "hidden" : ""}>
                    <label className="input-group" htmlFor="abn">
                        <span className="label label-large">ABN</span>
                        <input className="input" type="text" id="abn" name="abn" value={props.customerDetails.abn} onChange={(e) => handleGSTChange(e)} disabled={props.readOnly}></input>
                    </label>
                    <span className="label errors marginLeftLabelLarge">{props.errors["abn"]}</span>
                </div>
                <div className={props.customerDetails.gstRegistered == 0 ? "" : "hidden"}>
                    <label className="input-group" htmlFor="acn">
                        <span className="label label-large">ACN</span>
                        <input className="input" type="text" id="acn" name="acn" value={props.customerDetails.acn} onChange={(e) => handleGSTChange(e)} disabled={props.readOnly}></input>
                    </label>
                    <span className="label errors marginLeftLabelLarge">{props.errors["acn"]}</span>
                </div>

                <label className="input-group" htmlFor="accountTypeId">
                    <span className="label label-large">Account Type</span>
                    <select className="select" id="accountTypeId" name="accountTypeId" value={props.customerDetails.accountTypeId} onChange={(e) => handleAcctChange(e)} disabled={(props.customerDetails.id > 0 && !canCreateAccountCustomers) || props.readOnly}>
                        <option hidden defaultValue="-1"></option>
                        {accountTypes.map(type =>
                            <option key={type.id} value={type.id}>{type.name}</option>
                        )};
                    </select>
                </label>
                <span className="label errors marginLeftLabelLarge">{props.errors["accountTypeId"]}</span>
                <label className="input-group" htmlFor="terms">
                    <span className="label label-large">Account Terms</span>
                    <select className="select" id="terms" name="terms" value={props.customerDetails.terms} onChange={(e) => handleChangeNumber(e)} disabled={props.readOnly}>
                        <option hidden defaultValue="-1"></option>
                        {termsOptions.map(term =>
                            <option key={term.id} value={term.id}>{term.name}</option>
                        )};
                    </select>
                </label>
                <span className="label errors marginLeftLabelLarge">{props.errors["terms"]}</span>
                <div className={props.customerDetails.id === 0 || props.systemCompanyId === 2 ? "" : "hidden"}>
                    <label className="input-group" htmlFor="accountLimit">
                        <span className="label label-large">Account Limit {props.customerDetails.id === 0 ? "Scaffold" : ""}</span>
                        <input className="input" type="number" id="accountLimit" name="accountLimit" value={props.customerDetails.accountLimit} onChange={(e) => handleChangeNumber(e)} disabled={props.readOnly}></input>
                    </label>
                    <span className="label errors marginLeftLabelLarge">{props.errors["accountLimit"]}</span>
                </div>
                <div className={props.customerDetails.id === 0 || props.systemCompanyId === 3 ? "" : "hidden"}>
                    <label className="input-group" htmlFor="accountLimitDunny">
                        <span className="label label-large">Account Limit {props.customerDetails.id === 0 ? "Dunny" : ""}</span>
                        <input className="input" type="number" id="accountLimitDunny" name="accountLimitDunny" value={props.customerDetails.accountLimitDunny} onChange={(e) => handleChangeNumber(e)} disabled={props.readOnly}></input>
                    </label>
                    <span className="label errors marginLeftLabelLarge">{props.errors["accountLimitDunny"]}</span>
                </div>
                <label className="input-group" htmlFor="accountContact">
                    <span className="label label-large">Account Contact</span>
                    <input className="input" type="text" id="accountContact" name="accountContact" value={props.customerDetails.accountContact} onChange={(e) => handleChangeString(e)} disabled={props.readOnly}></input>
                </label>
                <label className="input-group" htmlFor="phone">
                    <span className="label label-large">Phone</span>
                    <input className="input" type="text" id="phone" name="phone" value={props.customerDetails.phone} onChange={(e) => handleChangeString(e)} disabled={props.readOnly}></input>
                </label>
                <span className="label errors marginLeftLabelLarge">{props.errors["phone"]}</span>

                <label className="input-group" htmlFor="invoiceEmail">
                    <span className="label label-large">Invoice Email</span>
                    <input className="input" type="text" id="invoiceEmail" name="invoiceEmail" value={props.customerDetails.invoiceEmail} onChange={(e) => handleChangeString(e)} disabled={props.readOnly}></input>
                </label>
                <span className="label errors marginLeftLabelLarge">{props.errors["invoiceEmail"]}</span>

                <label className="input-group" htmlFor="statusId">
                    <span className="label label-large">Status</span>
                    <select className="select" id="statusId" name="statusId" value={props.customerDetails.statusId} onChange={(e) => handleChangeNumber(e)} disabled={props.customerDetails.id == 0 || props.readOnly ? true : false}>
                        {statusOptions.map(status =>
                            <option key={status.id} value={status.id}>{status.name}</option>
                        )};
                    </select>
                </label>
                <span className="label errors marginLeftLabelLarge">{props.errors["statusId"]}</span>

                <label className="input-group" htmlFor="lockAccount">
                    <span className="label label-large">Lock Account</span>
                    <input className="checkbox customer__checkbox" type="checkbox" id="lockAccount" name="lockAccount" checked={props.customerDetails.lockAccount} onClick={(e) => handleCheckboxChange(e)} disabled={props.readOnly}></input>
                </label>

            </div>
        </div>
    );
    
    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );
}

export default CustomerDetail;